<template>
  <div>
    <h2>General Questions</h2>
    <div class="form-group">

    <div class="col-xs-12" v-if="canfca == 1">
      <label class="control-label">FCA Firm Reference Number</label>
      <p>
        Model Office RegTech acts as a governance, risk and compliance hub, centralising all relevant compliance data for instant access for reporting requirements. This information will enable you to collate relevant business and regulatory information in one place and gain real time data to report as necessary. Once input you can then access the FCA and Companies House information on the regulatory results dashboard when you have audited your firm across all relevant regulatory keys.
      </p>
      <div class="input-group">
        <input
            type="text"
            class="form-control"
            name="fca_firm_reference_number"
            id="fca_firm_reference_number"
            placeholder="What is your FCA Firm Reference Number?"
            v-model="fcaFirmReferenceNumberData"
        />
        <span class="input-group-btn">
          <button class="btn btn-default" type="button" style="height: 40px;" v-on:click="getFcaData">
            <i class="fa fa-refresh" id="get_fca_data"></i>
          </button>
        </span>
      </div>
      <p v-if="fcaMessage">{{ fcaMessage }}</p>
    </div>

    <div v-if="typeFirmDataOptions" class="col-xs-12">
      <label class="control-label">Please tell us your firm type?</label>
      <select
          name="firm_type_id"
          id="firm_type_id"
          class="form-control"
          v-model="firmTypeData">
        <option value="">Please select...</option>
        <option v-for="item in typeFirmDataOptions" :value="item.id" :key="item.name">{{ item.name }}</option>
      </select>
    </div>

    <div v-if="showFields">
      <div class="col-xs-12">
        <label class="control-label" for="name">What is your company name?</label>
        <v-select
            id="name"
            v-model="companyNameData"
            label="current_name"
            :reduce="companyNameData => companyNameData.current_name"
            :options="companyNameDataOptions"
            taggable
            placeholder="What is your company name?">
        </v-select>
        <input type="hidden" v-model="companyNameData" name="name" />
      </div>

      <div class="col-xs-12">
        <label class="control-label" for="name">What is your phone number?</label>
        <v-select
            id="phone_number"
            v-model="phoneNumberData"
            label="phone_number"
            :reduce="phoneNumberData => phoneNumberData.phone_number"
            :options="phoneNumberDataOptions"
            taggable
            placeholder="What is your phone number?">
        </v-select>
        <input type="hidden" v-model="phoneNumberData" name="phone_number" />
      </div>

      <div class="col-xs-12">
        <label class="control-label" for="name">Where are you based?</label>
        <v-select
            id="location"
            v-model="locationData"
            label="town"
            :reduce="locationData => locationData.town"
            :options="locationDataOptions"
            taggable
            placeholder="Where are you based?">
        </v-select>
        <input type="hidden" v-model="locationData" name="location" />
      </div>

      <div class="col-xs-12">
        <label class="control-label">How many employees / staff?</label>
        <select
            name="staff"
            id="staff"
            class="form-control"
            v-model="staffData">
          <option v-for="(value,label) in staffDataOptions" :value="value" :key="label">{{ label }}</option>
        </select>
      </div>

      <div class="col-xs-12">
        <label class="control-label">How large is your client base?</label>
        <select
            name="client_base"
            id="client_base"
            class="form-control"
            v-model="clientBaseData">
          <option v-for="(value,label) in clientBaseDataOptions" :value="value" :key="label">{{ label }}</option>
        </select>
      </div>



      <div class="col-xs-12" v-if="isMOUKAccount() || isSbgAccount()">
        <label class="control-label">What is the average age of your clients?</label>
        <select
            name="average_age_clients"
            id="average_age_clients"
            class="form-control"
            v-model="averageAgeClientsData">
          <option v-for="(value,label) in averageAgeClientsDataOptions" :value="value" :key="label">{{ label }}</option>
        </select>
      </div>

      <div class="col-xs-12" v-if="isMOUKAccount() || isSbgAccount()">
        <label class="control-label">What is your Annual Recurring Revenue?</label>
        <select
            name="annual_recurring_revenue"
            id="annual_recurring_revenue"
            class="form-control"
            v-model="annualRecurringRevenueData">
          <option v-for="(value,label) in annualRecurringRevenueDataOptions" :value="value" :key="label">{{ label }}</option>
        </select>
      </div>



      <div class="col-xs-12">
        <label class="control-label">Which level of annual turnover best matches last years figures?</label>
        <select
            name="turnover"
            id="turnover"
            class="form-control"
            v-model="turnoverData">
          <option v-for="(value,label) in turnoverDataOptions" :value="value" :key="label">{{ label }}</option>
        </select>
      </div>

      <div class="col-xs-12">
        <label class="control-label">Assets Under Management?</label>
        <select
            name="assets_under_management"
            id="assets_under_management"
            class="form-control"
            v-model="assetsUnderManagementData">
          <option v-for="(value,label) in assetsUnderManagementOptions" :value="value" :key="label">{{ label }}</option>
        </select>
      </div>

      <div class="col-xs-12" v-if="isMOUKAccount() || isSbgAccount()">
        <label class="control-label">What is your current or last year EBITDA?</label>
        <input
            name="ebitda"
            type="text"
            id="ebitda"
            v-model="ebitdaData"
            class="form-control"
            placeholder="What is your current or last year EBITDA?"
        />
      </div>

      <div class="col-xs-12" v-if="isMOUKAccount() || isSbgAccount()">
        <label class="control-label">What fee structure do you use?</label>
        <input
            name="fee_structure"
            type="text"
            id="fee_structure"
            v-model="feeStructureData"
            class="form-control"
            placeholder="What fee structure do you use?"
        />
      </div>

      <div class="col-xs-12">
        <label class="control-label">Which platform do you use?</label>
        <input
            name="platform"
            type="text"
            id="platform"
            v-model="platformData"
            class="form-control"
            placeholder="Which platform do you use?"
        />
      </div>

      <div class="col-xs-12">
        <label class="control-label">Which compliance firm do you use?</label>
        <input
            name="compliance_firm"
            type="text"
            id="compliance_firm"
            v-model="complianceFirmData"
            class="form-control"
            placeholder="Which compliance firm do you use?"
        />
      </div>

      <div class="col-xs-12">
        <label class="control-label">Which practice management (back-office) technology do you use?</label>
        <select
            name="back_office"
            id="back_office"
            class="form-control"
            v-model="backOfficeData">
          <option v-for="(value,label) in backOfficeOptions" :value="value" :key="label">{{ label }}</option>
        </select>
        <template v-if="backOfficeData === 'Other'">
          <label class="control-label">Please add your practice management tech</label>
          <input
              name="practice_management_technology"
              type="text"
              id="practice_management_technology"
              v-model="practiceManagementTechnologyData"
              class="form-control"
              placeholder="Which practice management (back-office) technology do you use? Please specify if not listed."
          />
        </template>
      </div>

      <div class="col-xs-12">
        <label class="control-label">Which attitude to risk technology do you use?</label>
        <input
            name="risk_technology"
            type="text"
            id="risk_technology"
            v-model="riskTechnologyData"
            class="form-control"
            placeholder="Which attitude to risk technology do you use?"
        />
      </div>

      <div class="col-xs-12">
        <label class="control-label">Which cashflow modelling technology do you use?</label>
        <input
            name="cashflow_technology"
            type="text"
            id="cashflow_technology"
            v-model="cashflowTechnologyData"
            class="form-control"
            placeholder="Which cashflow modelling technology do you use?"
        />
      </div>

    </div>
    </div>

    <button v-if="showFields" type="submit" class="btn btn-primary submit">
      <template v-if="additional">Save</template>
      <template v-else>Submit</template>
    </button>

  </div>
</template>

<script>
export default {
  name: "AdditionalFormComponent",
  props: {
    fca_firm_reference_number: {
      type: String,
      default: null
    },
    company_name: {
      type: String,
      default: null
    },
    phone_number: {
      type: String,
      default: null
    },
    location: {
      type: String,
      default: null
    },
    staff: {
      type: String,
      default: null
    },
    client_base: {
      type: String,
      default: ''
    },
    average_age_clients: {
      type: String,
      default: ''
    },
    annual_recurring_revenue: {
      type: String,
      default: ''
    },
    turnover: {
      type: String,
      default: null
    },
    ebitda: {
      type: String,
      default: null
    },
    fee_structure: {
      type: String,
      default: null
    },
    firm_type: {
      type: String,
      default: null
    },
    platform: {
      type: String,
      default: null
    },
    compliance_firm: {
      type: String,
      default: null
    },
    practice_management_technology: {
      type: String,
      default: null
    },
    back_office: {
      type: String,
      default: 'io'
    },
    risk_technology: {
      type: String,
      default: null
    },
    cashflow_technology: {
      type: String,
      default: null
    },
    assets_under_management: {
      type: String,
      default: null
    },
    additional: {
      type: Number,
      default: false
    },
    fields: {
      type: Object,
      default: null
    },
    canfca: {
      type: [Number, String],
      default: null,
    },
    network_name: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      fcaFirmReferenceNumberData: this.fca_firm_reference_number,
      phoneNumberData: this.phone_number,
      locationData: this.location,
      companyNameData: this.company_name,
      staffData: this.staff,
      clientBaseData: this.client_base,
      averageAgeClientsData: this.average_age_clients,
      annualRecurringRevenueData: this.annual_recurring_revenue,
      turnoverData: this.turnover,
      ebitdaData: this.ebitda,
      feeStructureData: this.fee_structure,
      firmTypeData: this.firm_type,
      platformData: this.platform,
      complianceFirmData: this.compliance_firm,
      practiceManagementTechnologyData: this.practice_management_technology,
      backOfficeData: this.back_office,
      riskTechnologyData: this.risk_technology,
      cashflowTechnologyData: this.cashflow_technology,
      assetsUnderManagementData: this.assets_under_management,

      companyNameDataOptions: [],
      phoneNumberDataOptions: [],
      locationDataOptions: [],
      dataFCA: {},
      showFields: false,

      staffDataOptions: {
        'Please select...': '',
        '1-10': '1-10',
        '10-50': '10-50',
        '50+': '50+',
      },
      clientBaseDataOptions: {
        'Please select...': '',
        '0-500': '0-500',
        '500-1000': '500-1000',
        '1000+': '1000+',
      },
      averageAgeClientsDataOptions: {
        'Please select...': '',
        '20-30': '20-30',
        '30-40': '30-40',
        '40-50': '40-50',
        '50-60': '50-60',
        '60+': '60+',
      },
      annualRecurringRevenueDataOptions: {
        'Please select...': '',
        '<£100,000': '<£100,000',
        '£100,000-£500,000': '£100,000-£500,000',
        '£500,000-£1M': '£500,000-£1M',
        '£1M-£2M': '£1M-£2M',
        '£2M-£3M': '£2M-£3M',
        '£3-5M': '£3-5M',
        '£5M+': '£5M+',
      },
      turnoverDataOptions: {},
      baseBackOfficeOptions: {
        'intelliflo office': 'io',
        'IRESS': 'iress',
      },
      assetsUnderManagementOptions: {},
      typeFirmDataOptions: this.fields.firm_type_data_options,
      fcaMessage: null,
    };
  },
  methods: {
    getFcaData() {
      this.fcaMessage = null;
      this.inProcess( true)
      const frn = this.fcaFirmReferenceNumberData;

      axios.get(`/fca/get-for-additional-data/${frn}`).then((res) => {
        this.dataFCA = res.data.data;
        this.fcaFirmReferenceNumberData = frn;

        this.phoneNumberDataOptions = this.dataFCA.firmPhoneNumbers;
        this.locationDataOptions = this.dataFCA.firmTowns;
        this.companyNameDataOptions = this.dataFCA.firmNames;

        this.phoneNumberData = this.phoneNumberDataOptions?.[0]?.phone_number;
        this.locationData = this.locationDataOptions?.[0]?.town;
        this.companyNameData = this.companyNameDataOptions?.[0]?.current_name;

        if (!this.companyNameData) {
          this.fcaMessage = 'Not found data in FCA';
        }

        this.inProcess(false);
        this.showFields = true;
      }).catch((error) => {
        console.log('error', error)
        this.inProcess(false)
      })
    },
    inProcess(process) {
      const icon = document.getElementById('get_fca_data');
      if (process) {
        icon.classList.add("fa-spin");
      } else {
        icon.classList.remove("fa-spin");
      }
    },
    isSbgAccount() {
      return this.network_name === 'sbg' ?? false;
    },
    isMOUKAccount() {
      return this.network_name === '';
    },
    getOptionsList(name) {
      return axios.get(`/additional/form-data/options/${name}`)
          .then((res) => {
            if (name === 'turnover_v1' || name === 'turnover_v2') {
              this.turnoverDataOptions = res.data;
            }
            if (name === 'asset_under_management') {
              this.assetsUnderManagementOptions = res.data
            }
          })
          .catch((error) => {
            console.log('error', error);
            return [];
          });
    },
  },
  computed: {
    backOfficeOptions() {
      let options = { ...this.baseBackOfficeOptions };

      if (this.isMOUKAccount() || this.isSbgAccount()) {
        options = {
          ...options,
          'CURO': 'CURO',
          'Plannr': 'Plannr',
          'Other': 'Other',
        };
      }

      return options;
    },
  },
  created() {
    if(this.additional){
      this.showFields = true;
    }

    if (this.phone_number) {
      this.phoneNumberDataOptions.push({'phone_number': this.phone_number});
      this.phoneNumberData = this.phoneNumberDataOptions[0].phone_number;
    }

    if (this.location) {
      this.locationDataOptions.push({'town': this.location});
      this.locationData = this.locationDataOptions[0].town;
    }

    if (this.company_name) {
      this.companyNameDataOptions.push({'current_name': this.company_name});
      this.companyNameData = this.companyNameDataOptions[0].current_name;
    }

    if (this.canfca == 0) {
      this.showFields = true;
    }

    if (this.isMOUKAccount() || this.isSbgAccount()) {
      this.getOptionsList('turnover_v2');
    } else {
      this.getOptionsList('turnover_v1');
    }

    this.getOptionsList('asset_under_management');
  },
};
</script>

<style scoped>
>>> {
  /* v-select */
  --vs-font-size: 14px;
  --vs-line-height: 2;
  --vs-search-input-bg: #fcfcfc;
  --vs-dropdown-bg: #fcfcfc;
}
</style>